import service from '@/utils/server';
let model = '/fm/fmRole/'
export const queryList = data => {
    return service({
        url: model+'pageInfo',
        method: 'post',
        data
    })
};

export const saveObject = data => {
    return service({
        url: model+'add',
        method: 'post',
        data
    })
};

export const updateObject = data => {
    return service({
        url: model+'update',
        method: 'post',
        data
    })
};


export const getDeleteRole = data => {
  return service({
    url: model+'delete/'+data.roleId,
    method: 'post'
  })
};

//
export const getResetPermission = data => {
  return service({
    url: model+'resetPermission',
    method: 'post',
    data
  })
};

export const getMenuTreeList = data => {
  return service({
    url: model+'getMenuPageOpList',
    method: 'post',
    data
  })
};
export const getPageOpsByRoleAndMenu = data => {
  return service({
    url: model+'/getPageOpsByRoleAndMenu',
    method: 'post',
    data
  })
};

export const getMenuPageOpList = data => {
  return service({
    url: model+'getMenuPageOpList/'+data.clientId+"/"+data.roleId,
    method: 'post'
  })
};

export const getExportRoleData = data => {
  return service({
    url: model+'exportRole/' + data.id,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/auth/role/api/index.js